export default function LeadersIcon({ id, title, onClickEvt }) {
    return (
        <div onClick={onClickEvt}>
            <span className={`icon_title ${id}`}>{title}</span>
            <span className={`portfolio-icon ${id}`} />
        </div>
    );
}
